export default function TestimonialSection() {
  return (
    <section className="relative px-6 md:px-10 lg:px-16 py-16 md:py-24 bg-background-50 overflow-hidden">
      <div className="absolute top-10 left-6 md:left-10 opacity-[0.06]">
        <i className="ri-double-quotes-l text-foreground-900" style={{ fontSize: '120px' }}></i>
      </div>

      <div className="max-w-5xl mx-auto">
        <div className="relative bg-foreground-950 rounded-3xl overflow-visible">
          <div className="flex flex-col lg:flex-row">
            <div className="w-full lg:w-[35%] -mt-10 lg:-mt-12 lg:-ml-8 relative z-10">
              <div className="h-64 lg:h-full min-h-[320px] overflow-hidden rounded-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20stylish%20young%20man%20with%20a%20confident%20smile%20holding%20a%20smartphone%20in%20a%20modern%20industrial%20loft%20space%20with%20exposed%20brick%20wall%2C%20casual%20streetwear%20outfit%2C%20warm%20ambient%20lighting%2C%20editorial%20portrait%20photography%2C%20urban%20cool%20aesthetic%20with%20earthy%20tones&width=600&height=900&seq=testimonial-user-v3&orientation=portrait"
                  alt="CSSBuy Spreadsheet User Review"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="w-full lg:w-[65%] py-10 px-8 md:px-12 flex flex-col justify-center">
              <span className="text-background-50/30 font-heading text-7xl md:text-8xl leading-none mb-4">&ldquo;</span>
              <blockquote className="text-background-50 text-lg md:text-xl leading-relaxed mb-6">
                I have saved hundreds using these CSSBuy spreadsheet finds. The curated picks are always on point, and the daily updates mean I never miss a fresh drop. This hub completely changed how I shop for streetwear.
              </blockquote>
              <div className="mb-6">
                <p className="text-background-50 text-sm font-semibold">Marcus J.</p>
                <p className="text-foreground-400 text-xs">Streetwear Enthusiast &amp; Spreadsheet Hunter</p>
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-accent-500 text-background-50 text-sm font-semibold rounded-full hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer w-fit"
              >
                Start Finding Deals
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}